module.exports = __webpack_public_path__ + "static/media/patent-01.37353232.jpg";